((Article, $) => {

  const $dom = {};

  const pairProductsSliderOptions = {
    slidesToShow: 1,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: false,
    prevArrow: $('.js-article-products-arrow-left'),
    nextArrow: $('.js-article-products-arrow-right')
  };

  const relatedArticlesSliderOptions = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          autoplay: false,
          infinite: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          autoplay: false,
          infinite: false
        }
      }
    ]
  };

  const bindUIActions = () => {};

  const cacheDom = () => {
    $dom.pairProductsSlider = $('.js-article-product-slider-container');
    $dom.relatedArticlesSlider = $('.js-related-article-wrapper');
  };

  const initSliders = () => {
    $dom.pairProductsSlider.slick(pairProductsSliderOptions);
    $dom.relatedArticlesSlider.slick(relatedArticlesSliderOptions);
  };
  
  Article.init = () => {
    bindUIActions();
    cacheDom();
    initSliders();
  };

})(window.Article = window.Article || {}, jQuery);